// React
import React, { useEffect } from "react";

// MUI
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// Authentication
import { useAuthState } from "react-firebase-hooks/auth";
import {
  auth
} from "../firebase";

// react router dom
import { useNavigate } from "react-router-dom";

function LoadingComponent(){
	return (
		<Box className="loading" sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
	);
}

export default LoadingComponent;